var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcaseReactCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3C15.0938 3 16 3.90625 16 5V13C16 14.125 15.0938 15 14 15H2C0.875 15 0 14.125 0 13V5C0 3.90625 0.875 3 2 3H4V2C4 0.90625 4.875 0 6 0H10C11.0938 0 12 0.90625 12 2V3H14ZM6 1.5C5.71875 1.5 5.5 1.75 5.5 2V3H10.5V2C10.5 1.75 10.25 1.5 10 1.5H6ZM2 4.5C1.71875 4.5 1.5 4.75 1.5 5V8H14.5V5C14.5 4.75 14.25 4.5 14 4.5H2ZM14 13.5C14.25 13.5 14.5 13.2812 14.5 13V9.5H10V10C10 10.5625 9.53125 11 9 11H7C6.4375 11 6 10.5625 6 10V9.5H1.5V13C1.5 13.2812 1.71875 13.5 2 13.5H14Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-settings"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseReactCustom);
export default __webpack_public_path__ + "static/media/briefcase-react-custom.9f59948e.svg";
export { ForwardRef as ReactComponent };